import { MagnifyingGlassIcon, PencilSimpleIcon } from "@phosphor-icons/react";

import {
  FilterButton,
  type Props as FilterButtonProps,
} from "@/components/FilterButton/FilterButton";
import { LinearProgress } from "@/components/LinearProgress/LinearProgress";

type Props = Omit<FilterButtonProps, "fullWidth"> & {
  progress?:
    | {
        variant: "indeterminate";
      }
    | { variant: "determinate"; value: number };
};

export function HeaderSearchButton({ children, progress, ...props }: Props) {
  return (
    <FilterButton fullWidth borderRadius="var(--radius-2xl)" {...props}>
      <div className="flex w-full items-center gap-3">
        <MagnifyingGlassIcon
          size={20}
          className="shrink-0 fill-text-disabled-interactive"
        />

        <div className="overflow-hidden">{children}</div>
        <div className="ms-auto flex shrink-0 gap-1">
          <div className="h-6 w-[1px] bg-stroke-neutral-soft" />
          <PencilSimpleIcon
            size={20}
            className="fill-text-disabled-interactive"
          />
        </div>
      </div>
      {progress ? (
        <div className="absolute bottom-0 h-1 w-full overflow-hidden">
          <LinearProgress {...progress} />
        </div>
      ) : null}
    </FilterButton>
  );
}
